import Stack from '@mui/material/Stack';

import ENGINETYPE from '@/constants/engineTypeConstants';
import type { Car } from '@/types/Car';

import ElectricVehicleInfo from '../ElectricVehicleInfo/ElectricVehicleInfo';
import Location from '../Location/Location';
import Name from '../Name/Name';
import PriceAndMileage from '../PriceAndMileage/PriceAndMileage';

type CarTileDescriptionProps = {
  car: Car;
};

const { electric, hybrid, plugin } = ENGINETYPE;

const CarTileDescription = ({ car }: CarTileDescriptionProps) => {
  const {
    year,
    make,
    model,
    trim,
    price,
    mileage,
    distance,
    engineType,
    stockNumber,
    originalPrice,
  } = car;

  const hasPriceDrop = car.statusInfo.hasPriceDrop;

  const showElectricVehicleInfo: boolean =
    engineType?.toLowerCase() === electric ||
    engineType?.toLowerCase() === hybrid ||
    engineType?.toLowerCase() === plugin;

  return (
    <>
      <Name
        year={year}
        make={make}
        model={model}
        trim={trim}
        stockNumber={stockNumber}
      />
      <PriceAndMileage
        price={price}
        originalPrice={originalPrice}
        mileage={mileage}
        hasPriceDrop={hasPriceDrop}
      />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mt: 4 }}
      >
        <Location locationInfo={car.location} distance={distance} />
        {showElectricVehicleInfo && (
          <ElectricVehicleInfo carEngineType={engineType} />
        )}
      </Stack>
    </>
  );
};

export default CarTileDescription;
